import { render, staticRenderFns } from "./NflPositionOpti.vue?vue&type=template&id=15aff01a&scoped=true"
import script from "./NflPositionOpti.vue?vue&type=script&lang=js"
export * from "./NflPositionOpti.vue?vue&type=script&lang=js"
import style0 from "./NflPositionOpti.vue?vue&type=style&index=0&id=15aff01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aff01a",
  null
  
)

export default component.exports